import Filter from "./Filter";
import Sort from "./Sort";

export default function Aside() {
  return (
    <aside>
        <div className="sidebar-items">
          <Sort/>
          <Filter/>
        </div>
      </aside>
  )
}